"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function Checkmark(props) {
    return (React.createElement("svg", Object.assign({ width: 60, height: 60, viewBox: "0 0 60 60" }, props),
        React.createElement("title", null, "Icon.Checkmark"),
        React.createElement("g", { fill: "#2AD2C9", fillRule: "evenodd" },
            React.createElement("path", { d: "M30 56c14.36 0 26-11.64 26-26S44.36 4 30 4 4 15.64 4 30s11.64 26 26 26zm0 4C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30 0 16.569-13.431 30-30 30z", fillRule: "nonzero" }),
            React.createElement("path", { d: "M40.377 18L26.54 31.803l-6.932-6.91L15 29.5 26.54 41 45 22.607z" }))));
}
exports.default = Checkmark;
//# sourceMappingURL=Checkmark.js.map